var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHexagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 131,
    height: 144,
    viewBox: "0 0 131 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.303,
    y1: 0.651,
    x2: 0.795,
    y2: 0.446,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8a758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f05c38"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Polygon_1",
    x: 0,
    y: 0,
    width: 131,
    height: 144,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f05c38",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_2_3",
    "data-name": "Component 2 \\u2013 3",
    transform: "translate(22.5 12.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -22.5, -12.5)",
    filter: "url(#Polygon_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-2",
    "data-name": "Polygon 1",
    d: "M59.794,0A25,25,0,0,1,81.461,12.529l10.36,18a25,25,0,0,1,0,24.942l-10.36,18A25,25,0,0,1,59.794,86H39.206A25,25,0,0,1,17.539,73.471l-10.36-18a25,25,0,0,1,0-24.942l10.36-18A25,25,0,0,1,39.206,0Z",
    transform: "translate(108.5 12.5) rotate(90)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagon);
export default __webpack_public_path__ + "static/media/hexagon.1da925ca85eae60d196903bc5d9c863e.svg";
export { ForwardRef as ReactComponent };